export default __webpack_public_path__ + "static/media/vcode-ico.dc30b8b1.svg";